import './array-from'

global.__DEV__ = true
